var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 4.75H6C4.20507 4.75 2.75 6.20507 2.75 8V18C2.75 19.7949 4.20507 21.25 6 21.25H18C19.7949 21.25 21.25 19.7949 21.25 18V8C21.25 6.20507 19.7949 4.75 18 4.75Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 2.75V6.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 9.25H20.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 2.75V6.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 14C8.66421 14 9 13.6642 9 13.25C9 12.8358 8.66421 12.5 8.25 12.5C7.83579 12.5 7.5 12.8358 7.5 13.25C7.5 13.6642 7.83579 14 8.25 14Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 14C12.6642 14 13 13.6642 13 13.25C13 12.8358 12.6642 12.5 12.25 12.5C11.8358 12.5 11.5 12.8358 11.5 13.25C11.5 13.6642 11.8358 14 12.25 14Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 14C16.6642 14 17 13.6642 17 13.25C17 12.8358 16.6642 12.5 16.25 12.5C15.8358 12.5 15.5 12.8358 15.5 13.25C15.5 13.6642 15.8358 14 16.25 14Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 18C8.66421 18 9 17.6642 9 17.25C9 16.8358 8.66421 16.5 8.25 16.5C7.83579 16.5 7.5 16.8358 7.5 17.25C7.5 17.6642 7.83579 18 8.25 18Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 18C12.6642 18 13 17.6642 13 17.25C13 16.8358 12.6642 16.5 12.25 16.5C11.8358 16.5 11.5 16.8358 11.5 17.25C11.5 17.6642 11.8358 18 12.25 18Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 18C16.6642 18 17 17.6642 17 17.25C17 16.8358 16.6642 16.5 16.25 16.5C15.8358 16.5 15.5 16.8358 15.5 17.25C15.5 17.6642 15.8358 18 16.25 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSchedule);
export default __webpack_public_path__ + "static/media/menu_schedule.65712e3c1a835f1272b4a0634243c66c.svg";
export { ForwardRef as ReactComponent };